const refreshThresholdSeconds = 36 * 60 * 60;
const refreshCooldownMilliseconds = 15 * 60 * 1000;
let lastRefreshAttemptAt: number | null = null;

export const canStartTokenRefresh = (nowMilliseconds: number = Date.now()): boolean => {
  if (
    lastRefreshAttemptAt !== null &&
    nowMilliseconds - lastRefreshAttemptAt < refreshCooldownMilliseconds
  ) {
    return false;
  }

  lastRefreshAttemptAt = nowMilliseconds;
  return true;
};

const getJwtPayload = (token: string): Record<string, unknown> | null => {
  const segments = token.split(".");
  if (segments.length !== 3) {
    return null;
  }

  try {
    const base64 = segments[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
    return JSON.parse(window.atob(padded));
  } catch (_error) {
    return null;
  }
};

export const getJwtExpiration = (token: string): number | null => {
  const payload = getJwtPayload(token);
  return typeof payload?.exp === "number" && Number.isFinite(payload.exp)
    ? payload.exp
    : null;
};

export const shouldRefreshJwt = (
  token: string,
  nowMilliseconds: number = Date.now()
): boolean => {
  const expiration = getJwtExpiration(token);
  if (expiration === null) {
    return false;
  }

  const sessionExpiration = getJwtPayload(token)?.session_expires_at;
  if (
    typeof sessionExpiration === "number" &&
    Number.isFinite(sessionExpiration) &&
    expiration >= sessionExpiration
  ) {
    return false;
  }

  const nowSeconds = Math.floor(nowMilliseconds / 1000);
  return expiration - nowSeconds <= refreshThresholdSeconds;
};
